import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/marketArea';

const namespace = 'ANALYSIS';

export const SEARCH_MARKET_AREA = createRequestTypes(
  `${namespace}/SEARCH_MARKET_AREA`,
);

export const searchMarketArea = makeApiActionCreatorV3(
  api.searchMarketArea,
  SEARCH_MARKET_AREA[START],
  SEARCH_MARKET_AREA[SUCCESS],
  SEARCH_MARKET_AREA[ERROR],
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const FETCH_MARKET_AREA_GENERAL_INFO = createRequestTypes(
  `${namespace}/FETCH_MARKET_AREA_GENERAL_INFO`,
);

export const fetchMarketAreaGeneralInfo = makeApiActionCreatorV3(
  api.fetchMarketAreaGeneralInfo,
  FETCH_MARKET_AREA_GENERAL_INFO[START],
  FETCH_MARKET_AREA_GENERAL_INFO[SUCCESS],
  FETCH_MARKET_AREA_GENERAL_INFO[ERROR],
);

export const UPDATE_MARKET_AREA_GENERAL_INFO = createRequestTypes(
  `${namespace}/UPDATE_MARKET_AREA_GENERAL_INFO`,
);

export const updateMarketAreaGeneralInfo = makeApiActionCreatorV3(
  api.updateMarketAreaGeneralInfo,
  UPDATE_MARKET_AREA_GENERAL_INFO[START],
  UPDATE_MARKET_AREA_GENERAL_INFO[SUCCESS],
  UPDATE_MARKET_AREA_GENERAL_INFO[ERROR],
);

export const FETCH_MARKET_AREA_STATISTICS = createRequestTypes(
  `${namespace}/FETCH_MARKET_AREA_STATISTICS`,
);

export const fetchMarketAreaStatistics = makeApiActionCreatorV3(
  api.fetchMarketAreaStatistics,
  FETCH_MARKET_AREA_STATISTICS[START],
  FETCH_MARKET_AREA_STATISTICS[SUCCESS],
  FETCH_MARKET_AREA_STATISTICS[ERROR],
);

export const PROCESS_MARKET_AREA_STATISTICS = createRequestTypes(
  `${namespace}/PROCESS_MARKET_AREA_STATISTICS`,
);

export const processMarketAreaStatistics = makeApiActionCreatorV3(
  api.processMarketAreaStatistics,
  PROCESS_MARKET_AREA_STATISTICS[START],
  PROCESS_MARKET_AREA_STATISTICS[SUCCESS],
  PROCESS_MARKET_AREA_STATISTICS[ERROR],
);

export const FETCH_MARKET_AREA_SUBDIVISIONS = createRequestTypes(
  `${namespace}/FETCH_MARKET_AREA_SUBDIVISIONS`,
);

export const fetchMarketAreaSubdivisions = makeApiActionCreatorV3(
  api.fetchMarketAreaSubdivisions,
  FETCH_MARKET_AREA_SUBDIVISIONS[START],
  FETCH_MARKET_AREA_SUBDIVISIONS[SUCCESS],
  FETCH_MARKET_AREA_SUBDIVISIONS[ERROR],
);

export const FETCH_SALES_TYPES = createRequestTypes(
  `${namespace}/FETCH_SALES_TYPES`,
);

export const fetchSalesTypes = makeApiActionCreatorV3(
  api.fetchSalesTypes,
  FETCH_SALES_TYPES[START],
  FETCH_SALES_TYPES[SUCCESS],
  FETCH_SALES_TYPES[ERROR],
);

export const FETCH_SALES_SOURCE = createRequestTypes(
  `${namespace}/FETCH_SALES_SOURCE`,
);

export const fetchSalesSource = makeApiActionCreatorV3(
  api.fetchSalesSource,
  FETCH_SALES_SOURCE[START],
  FETCH_SALES_SOURCE[SUCCESS],
  FETCH_SALES_SOURCE[ERROR],
);

export const FETCH_RATIO_TYPES = createRequestTypes(
  `${namespace}/FETCH_RATIO_TYPES`,
);

export const fetchRatioTypes = makeApiActionCreatorV3(
  api.fetchRatioTypes,
  FETCH_RATIO_TYPES[START],
  FETCH_RATIO_TYPES[SUCCESS],
  FETCH_RATIO_TYPES[ERROR],
);

export const FETCH_SALE_QUALIFIERS = createRequestTypes(
  `${namespace}/FETCH_SALE_QUALIFIERS`,
);

export const fetchSaleQualifiers = makeApiActionCreatorV3(
  api.fetchSaleQualifiers,
  FETCH_SALE_QUALIFIERS[START],
  FETCH_SALE_QUALIFIERS[SUCCESS],
  FETCH_SALE_QUALIFIERS[ERROR],
);

export const FETCH_SALE_SEARCH_PARAMETERS = createRequestTypes(
  `${namespace}/FETCH_SALE_SEARCH_PARAMETERS`,
);

export const fetchSaleSearchParameters = makeApiActionCreatorV3(
  api.fetchSaleSearchParameters,
  FETCH_SALE_SEARCH_PARAMETERS[START],
  FETCH_SALE_SEARCH_PARAMETERS[SUCCESS],
  FETCH_SALE_SEARCH_PARAMETERS[ERROR],
);

export const UPDATE_SALE_SEARCH_PARAMETERS = createRequestTypes(
  `${namespace}/UPDATE_SALE_SEARCH_PARAMETERS`,
);

export const updateSaleSearchParameters = makeApiActionCreatorV3(
  api.updateSaleSearchParameters,
  UPDATE_SALE_SEARCH_PARAMETERS[START],
  UPDATE_SALE_SEARCH_PARAMETERS[SUCCESS],
  UPDATE_SALE_SEARCH_PARAMETERS[ERROR],
);

export const FETCH_SALES = createRequestTypes(`${namespace}/FETCH_SALES`);

export const fetchSales = makeApiActionCreatorV3(
  api.fetchSales,
  FETCH_SALES[START],
  FETCH_SALES[SUCCESS],
  FETCH_SALES[ERROR],
);

export const RESET_SALES = 'ANALYSIS/RESET_SALES';

export function resetSales() {
  return async dispatch => {
    dispatch({
      type: RESET_SALES,
    });
  };
}

export const FETCH_BUILDING_PERMIT_SUMMARY = createRequestTypes(
  `${namespace}/FETCH_BUILDING_PERMIT_SUMMARY`,
);
export const fetchBuildingPermitSummary = makeApiActionCreatorV3(
  api.fetchBuildingPermitSummary,
  FETCH_BUILDING_PERMIT_SUMMARY[START],
  FETCH_BUILDING_PERMIT_SUMMARY[SUCCESS],
  FETCH_BUILDING_PERMIT_SUMMARY[ERROR],
);

export const FETCH_BUILDERS = createRequestTypes(`${namespace}/FETCH_BUILDERS`);
export const fetchBuilders = makeApiActionCreatorV3(
  api.fetchBuilders,
  FETCH_BUILDERS[START],
  FETCH_BUILDERS[SUCCESS],
  FETCH_BUILDERS[ERROR],
);

export const FETCH_RECHECKS = createRequestTypes(`${namespace}/FETCH_RECHECKS`);
export const fetchRechecks = makeApiActionCreatorV3(
  api.fetchRechecks,
  FETCH_RECHECKS[START],
  FETCH_RECHECKS[SUCCESS],
  FETCH_RECHECKS[ERROR],
);

export const FETCH_PROTEST_COUNTS = createRequestTypes(
  `${namespace}/FETCH_PROTEST_COUNTS`,
);
export const fetchProtestCounts = makeApiActionCreatorV3(
  api.fetchProtestCounts,
  FETCH_PROTEST_COUNTS[START],
  FETCH_PROTEST_COUNTS[SUCCESS],
  FETCH_PROTEST_COUNTS[ERROR],
);

export const FETCH_TREND_ANALYSIS_SALES = createRequestTypes(
  `${namespace}/FETCH_TREND_ANALYSIS_SALES`,
);
export const fetchTrendAnalysisSales = makeApiActionCreatorV3(
  api.fetchTrendAnalysisSales,
  FETCH_TREND_ANALYSIS_SALES[START],
  FETCH_TREND_ANALYSIS_SALES[SUCCESS],
  FETCH_TREND_ANALYSIS_SALES[ERROR],
);

export const FETCH_MARKET_AREA_POPULATION = createRequestTypes(
  `${namespace}/FETCH_MARKET_AREA_POPULATION`,
);
export const fetchMarketAreaPopulation = makeApiActionCreatorV3(
  api.fetchMarketAreaPopulation,
  FETCH_MARKET_AREA_POPULATION[START],
  FETCH_MARKET_AREA_POPULATION[SUCCESS],
  FETCH_MARKET_AREA_POPULATION[ERROR],
);

export const ANALYZE_SALES = createRequestTypes(`${namespace}/ANALYZE_SALES`);

export const analyzeSales = makeApiActionCreatorV3(
  api.analyzeSales,
  ANALYZE_SALES[START],
  ANALYZE_SALES[SUCCESS],
  ANALYZE_SALES[ERROR],
);

export const APPLY_MODIFIER_AND_LAUNCH_MARKET_AREA_JOB = createRequestTypes(
  `${namespace}/APPLY_MODIFIER_AND_LAUNCH_MARKET_AREA_JOB`,
);

export const applyModifierAndLaunchMarketAreaJob = makeApiActionCreatorV3(
  api.applyModifierAndLaunchMarketAreaJob,
  APPLY_MODIFIER_AND_LAUNCH_MARKET_AREA_JOB[START],
  APPLY_MODIFIER_AND_LAUNCH_MARKET_AREA_JOB[SUCCESS],
  APPLY_MODIFIER_AND_LAUNCH_MARKET_AREA_JOB[ERROR],
);

export const APPLY_MODIFIER_AND_RECALCULATE = createRequestTypes(
  `${namespace}/APPLY_MODIFIER_AND_RECALCULATE`,
);

export const applyModifierAndRecalculate = makeApiActionCreatorV3(
  api.applyModifierAndRecalculate,
  APPLY_MODIFIER_AND_RECALCULATE[START],
  APPLY_MODIFIER_AND_RECALCULATE[SUCCESS],
  APPLY_MODIFIER_AND_RECALCULATE[ERROR],
);

export const RESET_MODIFIER_AND_RECALCULATE = createRequestTypes(
  `${namespace}/RESET_MODIFIER_AND_RECALCULATE`,
);

export const resetModifierAndRecalculate = makeApiActionCreatorV3(
  api.resetModifierAndRecalculate,
  RESET_MODIFIER_AND_RECALCULATE[START],
  RESET_MODIFIER_AND_RECALCULATE[SUCCESS],
  RESET_MODIFIER_AND_RECALCULATE[ERROR],
);

export const FETCH_RECALCULATION_JOB_STATUS = createRequestTypes(
  `${namespace}/FETCH_RECALCULATION_JOB_STATUS`,
);

export const fetchRecalculationJobStatus = makeApiActionCreatorV3(
  api.fetchRecalculationJobStatus,
  FETCH_RECALCULATION_JOB_STATUS[START],
  FETCH_RECALCULATION_JOB_STATUS[SUCCESS],
  FETCH_RECALCULATION_JOB_STATUS[ERROR],
);

export const FETCH_APPRAISERS = createRequestTypes(
  `${namespace}/FETCH_APPRAISERS`,
);

export const fetchAppraisers = makeApiActionCreatorV3(
  api.fetchAppraisers,
  FETCH_APPRAISERS[START],
  FETCH_APPRAISERS[SUCCESS],
  FETCH_APPRAISERS[ERROR],
);

export const FETCH_CODE_FILE = createRequestTypes(
  `${namespace}/FETCH_CODE_FILE`,
);

export const fetchCodeFile = makeApiActionCreatorV3(
  api.fetchCodeFile,
  FETCH_CODE_FILE[START],
  FETCH_CODE_FILE[SUCCESS],
  FETCH_CODE_FILE[ERROR],
);

export const DELETE_MARKET_AREA_BUILDER = createRequestTypes(
  `${namespace}/DELETE_MARKET_AREA_BUILDER`,
);

export const deleteMarketAreaBuilder = makeApiActionCreatorV3(
  api.deleteMarketAreaBuilder,
  DELETE_MARKET_AREA_BUILDER[START],
  DELETE_MARKET_AREA_BUILDER[SUCCESS],
  DELETE_MARKET_AREA_BUILDER[ERROR],
);

export const INSERT_MARKET_AREA_BUILDER = createRequestTypes(
  `${namespace}/INSERT_MARKET_AREA_BUILDER`,
);

export const insertMarketAreaBuilder = makeApiActionCreatorV3(
  api.insertMarketAreaBuilder,
  INSERT_MARKET_AREA_BUILDER[START],
  INSERT_MARKET_AREA_BUILDER[SUCCESS],
  INSERT_MARKET_AREA_BUILDER[ERROR],
);

export const SET_SALE_AS_OUTLIER = createRequestTypes(
  `${namespace}/SET_SALE_AS_OUTLIER`,
);

export const setSaleAsOutlier = makeApiActionCreatorV3(
  api.setSaleAsOutlier,
  SET_SALE_AS_OUTLIER[START],
  SET_SALE_AS_OUTLIER[SUCCESS],
  SET_SALE_AS_OUTLIER[ERROR],
);

export const REMOVE_SALE_AS_OUTLIER = createRequestTypes(
  `${namespace}/REMOVE_SALE_AS_OUTLIER`,
);

export const removeSaleAsOutlier = makeApiActionCreatorV3(
  api.removeSaleAsOutlier,
  REMOVE_SALE_AS_OUTLIER[START],
  REMOVE_SALE_AS_OUTLIER[SUCCESS],
  REMOVE_SALE_AS_OUTLIER[ERROR],
);

export const SUBMIT_MARKET_AREA_DETAIL = createRequestTypes(
  `${namespace}/SUBMIT_MARKET_AREA_DETAIL`,
);

export const submitMarketAreaDetail = makeApiActionCreatorV3(
  api.submitMarketAreaDetail,
  SUBMIT_MARKET_AREA_DETAIL[START],
  SUBMIT_MARKET_AREA_DETAIL[SUCCESS],
  SUBMIT_MARKET_AREA_DETAIL[ERROR],
);

export const REOPEN_MARKET_AREA = createRequestTypes(
  `${namespace}/REOPEN_MARKET_AREA`,
);

export const reopenMarketArea = makeApiActionCreatorV3(
  api.reopenMarketArea,
  REOPEN_MARKET_AREA[START],
  REOPEN_MARKET_AREA[SUCCESS],
  REOPEN_MARKET_AREA[ERROR],
);

export const FETCH_SUBMISSION_STATISTICS = createRequestTypes(
  `${namespace}/FETCH_SUBMISSION_STATISTICS`,
);

export const fetchSubmissionStatistics = makeApiActionCreatorV3(
  api.fetchSubmissionStatistics,
  FETCH_SUBMISSION_STATISTICS[START],
  FETCH_SUBMISSION_STATISTICS[SUCCESS],
  FETCH_SUBMISSION_STATISTICS[ERROR],
);

export const UPLOAD_MARKET_AREA_FILE = createRequestTypes(
  `${namespace}/UPLOAD_MARKET_AREA_FILE`,
);

export const uploadMarketAreaFile = makeApiActionCreatorV3(
  api.uploadMarketAreaFile,
  UPLOAD_MARKET_AREA_FILE[START],
  UPLOAD_MARKET_AREA_FILE[SUCCESS],
  UPLOAD_MARKET_AREA_FILE[ERROR],
);

export const UPDATE_MARKET_AREA_FILE = createRequestTypes(
  `${namespace}/UPDATE_MARKET_AREA_FILE`,
);

export const updateMarketAreaFile = makeApiActionCreatorV3(
  api.updateMarketAreaFile,
  UPDATE_MARKET_AREA_FILE[START],
  UPDATE_MARKET_AREA_FILE[SUCCESS],
  UPDATE_MARKET_AREA_FILE[ERROR],
);

export const DOWNLOAD_MARKET_AREA_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_MARKET_AREA_FILE`,
);

export const downloadMarketAreaFile = makeApiActionCreatorV3(
  api.downloadMarketAreaFile,
  DOWNLOAD_MARKET_AREA_FILE[START],
  DOWNLOAD_MARKET_AREA_FILE[SUCCESS],
  DOWNLOAD_MARKET_AREA_FILE[ERROR],
);

export const DELETE_MARKET_AREA_FILE = createRequestTypes(
  `${namespace}/DELETE_MARKET_AREA_FILE`,
);

export const deleteMarketAreaFile = makeApiActionCreatorV3(
  api.deleteMarketAreaFile,
  DELETE_MARKET_AREA_FILE[START],
  DELETE_MARKET_AREA_FILE[SUCCESS],
  DELETE_MARKET_AREA_FILE[ERROR],
);

export const FETCH_MARKET_AREA_FILES = createRequestTypes(
  `${namespace}/FETCH_MARKET_AREA_FILES`,
);

export const fetchMarketAreaFiles = makeApiActionCreatorV3(
  api.fetchMarketAreaFiles,
  FETCH_MARKET_AREA_FILES[START],
  FETCH_MARKET_AREA_FILES[SUCCESS],
  FETCH_MARKET_AREA_FILES[ERROR],
);

export const UPDATE_MARKET_AREA_MODIFIERS = createRequestTypes(
  `${namespace}/UPDATE_MARKET_AREA_MODIFIERS`,
);

export const updateMarketAreaModifiers = makeApiActionCreatorV3(
  api.updateMarketAreaModifiers,
  UPDATE_MARKET_AREA_MODIFIERS[START],
  UPDATE_MARKET_AREA_MODIFIERS[SUCCESS],
  UPDATE_MARKET_AREA_MODIFIERS[ERROR],
);

export const CREATE_MARKET_AREA_COMMERCIAL = createRequestTypes(
  `${namespace}/CREATE_MARKET_AREA_COMMERCIAL`,
);

export const createMarketAreaCommercial = makeApiActionCreatorV3(
  api.createMarketAreaCommercial,
  CREATE_MARKET_AREA_COMMERCIAL[START],
  CREATE_MARKET_AREA_COMMERCIAL[SUCCESS],
  CREATE_MARKET_AREA_COMMERCIAL[ERROR],
);

export const FETCH_MARKET_AREA_USE_CODES = createRequestTypes(
  `${namespace}/FETCH_MARKET_AREA_USE_CODES`,
);

export const fetchMarketAreaUseCodes = makeApiActionCreatorV3(
  api.fetchMarketAreaUseCodes,
  FETCH_MARKET_AREA_USE_CODES[START],
  FETCH_MARKET_AREA_USE_CODES[SUCCESS],
  FETCH_MARKET_AREA_USE_CODES[ERROR],
);

export const INSERT_MARKET_AREA_USE_CODES = createRequestTypes(
  `${namespace}/INSERT_MARKET_AREA_USE_CODES`,
);

export const insertMarketAreaUseCodes = makeApiActionCreatorV3(
  api.insertMarketAreaUseCodes,
  INSERT_MARKET_AREA_USE_CODES[START],
  INSERT_MARKET_AREA_USE_CODES[SUCCESS],
  INSERT_MARKET_AREA_USE_CODES[ERROR],
);

export const Delete_MARKET_AREA_USE_CODE = createRequestTypes(
  `${namespace}/Delete_MARKET_AREA_USE_CODE`,
);

export const deleteMarketAreaUseCode = makeApiActionCreatorV3(
  api.deleteMarketAreaUseCode,
  Delete_MARKET_AREA_USE_CODE[START],
  Delete_MARKET_AREA_USE_CODE[SUCCESS],
  Delete_MARKET_AREA_USE_CODE[ERROR],
);
